import {Component} from "@angular/core";
import {MicroFormService} from "./micro-form.service";
import {MicroFormModel, microFormProvider} from "./micro-form.model";

@Component({
  selector: "micro-textarea",
  templateUrl: "./micro-textarea.template.pug",
  providers: [microFormProvider(MicroTextareaComponent)],
  outputs: MicroFormModel.OUTPUTS,
  inputs: MicroFormModel.INPUTS,
})
export class MicroTextareaComponent extends MicroFormModel {
  constructor(public microFormService: MicroFormService) {
    super(microFormService);
  }
}
